import { Text } from "@fluentui/react-components";
import { Resource } from "../../APIService/SearchService";
import { CommonInfo } from "../../CommonData/Config";
import "./ResourceModel.css"

type ResourceModelProps = {
    theme: string;
    resource: Resource;
    isAvailable: boolean;
    conflictCount: string;
    onRemove: () => void;
    onConflictAction: () => void;
    isConflictShown: boolean;
}

const ResourceModel = ({
    theme,
    resource,
    onRemove,
    isAvailable,
    conflictCount,
    onConflictAction,
    isConflictShown
}: ResourceModelProps) => {

    const getResourceIcon = (spaceType: string) => {
        if (spaceType.toLocaleLowerCase().includes("desk")) {
            return "icon-desk"
        } else if (spaceType.toLocaleLowerCase().includes("room")) {
            return "icon-room"
        } else if (spaceType.toLocaleLowerCase().includes("parking")) {
            return "icon-parking"
        } else if (spaceType.toLocaleLowerCase().includes("space")) {
            return "icon-person"
        } else {
            return "icon-space"
        }
    }

    const getResourceLocationString = () => {
        let locationString = ""
        if (resource.Location.Country) {
            locationString = locationString + resource.Location.Country
        }
        if (resource.Location.City) {
            locationString = locationString + ' | ' + resource.Location.City
        }
        if (resource.Location.Site) {
            locationString = locationString + ' | ' + resource.Location.Site
        }
        if (resource.Location.Building) {
            locationString = locationString + ' | ' + resource.Location.Building
        }
        if (resource.Location.Floor) {
            locationString = locationString + ' | ' + resource.Location.Floor
        }
        if (resource.Location.Zone) {
            locationString = locationString + ' | ' + resource.Location.Zone
        }
        return locationString;
    };

    return (
        <div className={`resourceContainer`}>
            {resource.SpaceTypeIcon ? (
                <img src={`${localStorage.getItem('tenantUrl')}${resource.SpaceTypeIcon}`} alt={resource.SpaceType} className="resourceIcon"/>
            ) : (
                <span className={`${getResourceIcon(resource.SpaceType)}`} style={{ fontSize: 30 }}/>
            )}
            <div className="bookingDetailContainer">
                <Text style={{ height: 24, fontSize: 14, fontStyle: "normal", fontWeight: 400, paddingRight: "10px", paddingLeft: "10px" }}>{resource.ResName}</Text>
                <Text style={{ fontSize: 12, fontStyle: "normal", fontWeight: 300, paddingRight: "10px", paddingLeft: "10px" }}>{getResourceLocationString()}</Text>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", height: 16, padding: "2px 10px", marginTop: "5px" }}>
                    {isAvailable ? (
                        <>
                            <img src={`${CommonInfo.folderName}/clockGreen.svg`} style={{ width: "12px", height: "12px" }} />
                            <Text style={{ marginLeft: "2px", fontSize: 12, fontStyle: "normal", fontWeight: 400, color: "#29C365" }}>Available</Text>
                        </>
                    ) : (
                        <div style={{cursor: "pointer"}} onClick={() => onConflictAction()}>
                            <img src={`${CommonInfo.folderName}/conflict.svg`} style={{ width: "12px", height: "12px" }} />
                            <Text style={{  marginLeft: "2px", fontSize: 12, fontStyle: "normal", fontWeight: 400, color: "#FFAE00" }}>{`${conflictCount} Conflict`}</Text>
                        </div>
                    )}
                </div>
            </div>
            <div className="seatIconContainer">
                <div style={{height: 20, alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    <img src={`${CommonInfo.folderName}/Assignspacelight.svg`} width={20} height={20}/>
                    <Text style={{ width: 8, lineHeight: 20, fontSize: 14, fontWeight: 400, justifyContent: "center" }}>{resource.Occupancy}</Text>
                </div>
                <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/checkoutlight.svg' : '/checkout.svg'}`} width={20} height={20} className="resourceContainerClose" onClick={() => onRemove()}/>
            </div>
        </div>
    );
};

export default ResourceModel;